import { getToken } from '../utils/getToken'

import { wrapFetch } from './FetchHelper'

export default {
  getMyTasks,
  get,
  create,
  update,
  delete: deleteTask,
}

function getMyTasks() {
  return wrapFetch(
    fetch('/api/general-tasks', {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${getToken()}`,
        Accept: 'application/json',
      },
    }),
  )
}

function get(id) {
  return wrapFetch(
    fetch(`/api/general-tasks/${id}`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${getToken()}`,
        Accept: 'application/json',
      },
    }),
  )
}

function create(task) {
  return wrapFetch(
    fetch('/api/general-tasks', {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${getToken()}`,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(task),
    }),
  )
}

function update(task) {
  return wrapFetch(
    fetch(`/api/general-tasks/${task.id}`, {
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${getToken()}`,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(task),
    }),
  )
}

function deleteTask(id) {
  return wrapFetch(
    fetch(`/api/general-tasks/${id}`, {
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${getToken()}`,
        Accept: 'application/json',
      },
    }),
  )
}
